<div class="container main-layout">
    <div class="right-container container-right-main">
        <div class="flex-header">
            <div class="float-left">
                <div class="title">
                    <div class="back-button" (click)="backbutton()">
                        &larr;
                    </div>
                    <div class="titleName">
                    Customer Profiles
                </div>
                </div>
            </div>
            <div class="float-right">
                <button class="right-button" (click)="createprofile()">
                    <span> Create Customer Profile</span>
                  </button>
            </div>
        </div>
        <div class="profile-wrapper">
            <div class="profile-block">
                <p class="firstPara">Default {{ autoMaticProfileCount }} Profiles</p>
                <div class="DoctorList">
                    <ng-container  *ngFor="let ele of doctorlist">
                    <div class="doctordiv" *ngIf="ele.profile_type === 'Automatic'">
                            <div class="doctordiv1">
                                <div class="DocNamePara">
                                    <p class="Doctorname">{{ele.full_name}}</p>
                                    <p class="Doctordesig">{{ele.occupation}}</p>
                                </div>
                                <div class="img-doctor">
                                    <img class="doctorimg" 
                                    [src]="ele.avatar_url ? ele.avatar_url : '../../../assets/images/red-icon.png'" 
                                    alt="Profile Image">                        
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
            
            <div class="profile-block">
                <p class="firstPara">Manual {{ manualProfileCount }} Profiles</p>
                <div class="DoctorList">
                <ng-container  *ngFor="let ele of doctorlist">
                    <div class="doctordiv" *ngIf="ele.profile_type !== 'Automatic'">
                            <div class="doctordiv2" (click)="onEditDoctorProfile(ele.profile_id)">
                                <div class="DocNamePara">
                                    <p class="Doctorname">{{ele.full_name}}</p>
                                    <p class="Doctordesig">{{ele.occupation}}</p>
                                </div>
                                <div class="img-doctor">
                                    <img class="doctorimg" [src]="ele.avatar_url ? ele.avatar_url : '../../../assets/images/red-icon.png'"
                                    alt="Profile Image">
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    </div>
            </div>
        </div>
          
    </div>
</div>
